/**
 * @type AppSizes
 */

const sizes = {
  topbar: {
    staticHeight: 110,
    fixedHeight: 70,
    banner: 30,
  },
  columnWidth: {
    medium: 1,
    small: 3,
    large: 4,
  },
  purpleBgHeightDesktop: 500,
  purpleBgHeightTablet: 300,
  purpleBgHeightMobile: 140,
  marginTopContainer: -530,
};

export default sizes;
